import { useMutation, MutationHookOptions } from '@companyon/graphql';
import { ACTIVATE_DEVICE_MUTATION } from '../../schema/mutations/activateDevice';

export function useActivateDeviceMutation(options?: MutationHookOptions) {
  return useMutation(ACTIVATE_DEVICE_MUTATION, options);
}
